import { Button } from "components/buttons/button";
import { ValidatedInput } from "components/forms/input";
import { Layout } from "components/layout";
import { useInput } from "lib/hooks/use-input";
import { emailRegex } from "lib/utils";
import Link from "next/link";
import { useState } from "react";

export const signup = () => {
  const displayName = useInput<string>("");
  const email = useInput<string>("");
  const confirmEmail = useInput<string>("");
  const password = useInput<string>("");
  const confirmedPassword = useInput<string>("");
  const newsletterSignup = useInput<boolean>(false);
  const [error, setError] = useState(false);
  const [isSubmitting, setSubmitting] = useState<boolean>(false);

  const handleSubmit = (event) => {
    setSubmitting(true);
    event.preventDefault();

    fetch("api/auth/signup", {
      method: "POST",
      body: JSON.stringify({
        display_name: displayName.value,
        email: email.value,
        password: password.value,
        newsletter_signup: newsletterSignup.value,
      }),
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.error) {
          setError(data.error.message);
          setSubmitting(false);
        } else {
          window.localStorage.setItem("jwt", data.jwt);
          location.assign(data.redirect);
        }
      })
      .catch((err) => {
        setError(true);
        setSubmitting(false);
      });
  };

  return (
    <>
      <Layout pageName='Sign Up'>
        <article className=' flex flex-col justify-center pt-12 pb-24 px-4 sm:px-6 lg:px-8 '>
          <form
            className='mx-auto mb-24 bg-gray-100 p-8 space-y-4 w-full max-w-md'
            method='POST'
            onSubmit={handleSubmit}
            id='signupForm'>
            <fieldset className='space-y-2'>
              <legend className='font-header tracking-wide text-4xl'>
                Sign up
              </legend>
              <ValidatedInput
                type='text'
                label='Display Name'
                id='display_name'
                name='display_name'
                bind={{ ...displayName.bind }}
              />
              <ValidatedInput
                type='email'
                id='email'
                bind={{ ...email.bind }}
                label='Email Address'
                inputProps={{ required: true, type: "email" }}
                showError={email.isModified && !emailRegex.test(email.value)}
              />
              <ValidatedInput
                type='email'
                id='confirmEmail'
                bind={{ ...confirmEmail.bind }}
                label='Confirm Email Address'
                inputProps={{ required: true, type: "email" }}
                showError={
                  confirmEmail.isModified && confirmEmail.value !== email.value
                }
                errorMessage={
                  "your email and email address confirmation do not match"
                }
              />
              <ValidatedInput
                id='password'
                type='password'
                bind={{ ...password.bind }}
                label='Password'
                inputProps={{ required: true, type: "password" }}
                showError={password.isModified && password.value.length < 8}
                errorMessage={
                  "Your password MUST be at least 8 characters long"
                }
              />
              <ValidatedInput
                id='confirmPassword'
                type='password'
                bind={{ ...confirmedPassword.bind }}
                label='Confirm Password'
                inputProps={{ required: true, type: "password" }}
                showError={
                  confirmedPassword.isModified &&
                  confirmedPassword.value !== password.value
                }
                errorMessage={
                  "Your confirmation password does not match your password"
                }
              />

              <label
                htmlFor='newsletter'
                className='flex flex-row flex-wrap space-x-2'>
                <input
                  {...newsletterSignup.bind}
                  type='checkbox'
                  name='newsletter'
                  id='newsletter'
                  className={`my-auto border-gray-300 text-green-default`}
                />
                <span className=''>Signup to our newsletter</span>
              </label>
            </fieldset>

            <section className='flex items-left justify-between flex-col space-y-2'>
              <div className='text-sm'>
                Already have an account?{" "}
                <Link href='/signin'>
                  <a
                    href='#'
                    className='font-medium text-green-default hover:underline'>
                    Sign in
                  </a>
                </Link>
              </div>
            </section>
            {error && (
              <section className='bg-red-50 text-red-700 text-sm px-4 py-4 rounded-md'>
                {error}
              </section>
            )}
            <section>
              <Button
                form='signupForm'
                buttonSize='lg'
                buttonType='primary'
                type='submit'
                onClick={handleSubmit}
                disabled={
                  !password.isModified ||
                  !email.isModified ||
                  !emailRegex.test(email.value) ||
                  password.value !== confirmedPassword.value ||
                  password.value.length < 8
                }
                loading={isSubmitting}
                className='w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-brand-yellow hover:bg-green-default focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-default disabled:cursor-not-allowed'>
                {isSubmitting ? "Signing Up" : "Sign up"}
              </Button>
            </section>
          </form>
        </article>
      </Layout>
    </>
  );
};

export default signup;
